var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10"},[(_vm.options)?_c('audio',{ref:"audioPlayer",staticClass:"video-js vjs-default-skin",attrs:{"id":"audioPlayer","crossorigin":"use-credentials"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }